__webpack_require__.p = "/nc_algorithm/";